
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TheTradeLimitDisplay',
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
})
